import React, { useState, useEffect } from "react"
import {
  CardBody,
  Container,
  Row,
  Col,
  Card,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import logo from "../../assets/images/onesquar.png"
import ReactPaginate from "react-paginate"
import classnames from "classnames"
import { URLS } from "../../Url"
import axios from "axios"
import { saveAs } from "file-saver"
import { FaFilePdf } from "react-icons/fa"

function State() {
  const [forms, setforms] = useState([])
  const [forms13, setforms13] = useState([])

  const [Doc, setDoc] = useState([])

  const [Subscribe, setSubscribe] = useState([])

  const [PendingListing, setPendingListing] = useState([])

  const [CompletedListing, setCompletedListing] = useState([])

  const [Users, setUsers] = useState([])

  const [activeTab1, setactiveTab1] = useState("5")

  const [Recharge, setRecharge] = useState([])

  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  const history = useHistory()

  const [Posts, setPosts] = useState([])

  const [Posters, setPosters] = useState([])

  const [listPerPage5] = useState(5)
  const [pageNumber5, setPageNumber5] = useState(0)

  const pagesVisited5 = pageNumber5 * listPerPage5
  const lists5 = Posters.slice(pagesVisited5, pagesVisited5 + listPerPage5)
  const pageCount5 = Math.ceil(Posters.length / listPerPage5)
  const changePage5 = ({ selected5 }) => {
    setPageNumber5(selected5)
  }

  useEffect(() => {
    GetOneActins()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const Actinid = sessionStorage.getItem("VendorId")

  const GetOneActins = () => {
    const data = {
      userId: Actinid,
    }

    var token = datas
    axios
      .post(URLS.GetIdVendor, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const responseData = res.data
        const updatedSubscribe = {
          ...responseData.vendorsubscriptions,
          invoiceAddCounts: responseData.invoiceAddCounts,
          cashbookCounts: responseData.cashbookCounts,
          userCreatedbyvenbdorCounts: responseData.userCreatedbyvenbdorCounts,
          allListingsCount: responseData.allListingsCount,
          uploadCount: responseData.uploadCount,
          postersCount: responseData.postersCount,
          addProductsCount: responseData.addProductsCount,
        }
        setSubscribe(updatedSubscribe)
        setforms(res.data?.vendor[0])
        setforms13(res.data?.referredUsers)
        setPosts(res.data?.userPosts)
        setDoc(res.data?.vendor[0]?.kyc)
        // setSubscribe(updatedSubscribe)
        setPendingListing(res.data?.completedListings)
        setCompletedListing(res.data?.rejectedListings)
        setUsers(res.data?.userCreatedbyvenbdor)
        setRecharge(res.data?.rechargehistory)
        setPosters(res.data?.vendorsavedtemplates)
      })
  }

  const Actinid1 = data => {
    sessionStorage.setItem("ListingId", data._id)
    history.push("/ViewVendorListing")
  }

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Recharge.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Recharge.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const [listPerPage1] = useState(5)
  const [pageNumber1, setPageNumber1] = useState(0)

  const pagesVisited1 = pageNumber1 * listPerPage1
  const lists1 = PendingListing.slice(
    pagesVisited1,
    pagesVisited1 + listPerPage1
  )
  const pageCount1 = Math.ceil(PendingListing.length / listPerPage1)
  const changePage1 = ({ selected }) => {
    setPageNumber1(selected)
  }

  const [listPerPage3] = useState(5)
  const [pageNumber3, setPageNumber3] = useState(0)

  const pagesVisited3 = pageNumber3 * listPerPage3
  const lists3 = CompletedListing.slice(
    pagesVisited3,
    pagesVisited3 + listPerPage3
  )
  const pageCount3 = Math.ceil(CompletedListing.length / listPerPage3)
  const changePage3 = ({ selected3 }) => {
    setPageNumber3(selected3)
  }

  const [listPerPage4] = useState(5)
  const [pageNumber4, setPageNumber4] = useState(0)

  const pagesVisited4 = pageNumber4 * listPerPage4
  const lists4 = Users.slice(pagesVisited4, pagesVisited4 + listPerPage4)
  const pageCount4 = Math.ceil(Users.length / listPerPage4)
  const changePage4 = ({ selected4 }) => {
    setPageNumber4(selected4)
  }
  const [listPerPage13] = useState(5)
  const [pageNumber13, setPageNumber13] = useState(0)

  const pagesVisited13 = pageNumber13 * listPerPage13
  const lists13 = forms13.slice(pagesVisited13, pagesVisited13 + listPerPage13)
  const pageCount13 = Math.ceil(forms13.length / listPerPage13)
  const changePage13 = ({ selected13 }) => {
    setPageNumber13(selected13)
  }

  const Actinids = data => {
    sessionStorage.setItem("RechargeId", data._id)
    history.push("/ViewService")
  }

  const [info, setinfo] = useState(false)

  const [Instructions, setInstructions] = useState([])

  function infos() {
    setinfo(!info)
  }

  const getinc = data => {
    setInstructions(data.image)
    infos()
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to InActive?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = data => {
    var token = datas
    axios
      .put(
        URLS.VendorBlockUpadate,
        { userId: data._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            history.push("/InActiveVendors")
            GetOneActins()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const manageDelete1 = data => {
    const confirmBox = window.confirm("Do you really want to Active?")
    if (confirmBox === true) {
      Delete1(data)
    }
  }

  const Delete1 = data => {
    var token = datas
    axios
      .put(
        URLS.VendorBlockUpadate,
        { userId: data._id },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            history.push("/Vendor")
            GetOneActins()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  const handleDownload = url => {
    saveAs(url, url.split("/").pop())
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Home "
            breadcrumbItem="View Business Man"
          />
          <Row>
            <Col>
              <Button
                onClick={() => history.goBack()}
                className="mb-3  m-1 "
                style={{ float: "right" }}
                color="primary"
              >
                <i className="far fa-arrow-alt-circle-left"></i> Back
              </Button>
              {Roles?.InActiveVendorActive == true ||
              Roles?.accessAll == true ? (
                <>
                  {forms.status == true ? (
                    <Button
                      onClick={() => {
                        manageDelete(forms)
                      }}
                      className="m-1 "
                      color="danger"
                      style={{ float: "right" }}
                    >
                      <div className="d-flex">
                        <i className="fas fa-user-lock px-1"></i>
                        InActive
                      </div>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => {
                        manageDelete1(forms)
                      }}
                      className="m-1 "
                      style={{ float: "right" }}
                      color="success"
                    >
                      <i className="fas fa-user-check px-1"></i>
                      Active
                    </Button>
                  )}
                </>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={12}>
                      <h5 className="mt-2 text-primary">Plan Information :-</h5>
                      <div className="table-rep-plugin mt-4 table-responsive">
                        <Table hover className="table table-bordered mb-4 ">
                          <thead>
                            <tr className="text-center">
                              <th>Plan Name</th>
                              <th>Plan Expired Date</th>
                              <th>Count</th>
                              <th>Poster's Count </th>
                              <th>Listing Count</th>
                              <th>Customer Add Count</th>
                              <th>Invoice Add Count</th>
                              <th>CashBook Entries Count</th>
                              <th>Upload Count</th>
                              <th>Products Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              className="text-center"
                              style={{ background: "rgb(220,220,220)" }}
                            >
                              <td rowSpan={2} className="pt-5">
                                {Subscribe?.planName}
                              </td>
                              <td rowSpan={2} className="pt-5">
                                <span className="badge bg-danger">
                                  {Subscribe?.planExpiryDate?.slice(0, 10)}
                                </span>
                              </td>
                              <td>Plan Count</td>
                              <td>{Subscribe?.planPostCount}</td>
                              <td>{Subscribe?.planListingCount}</td>
                              <td>{Subscribe?.planCutsomerAddCount}</td>
                              <td>{Subscribe?.planInvoiceAddCount}</td>
                              <td>{Subscribe?.planCashBookEntriesCount}</td>
                              <td>{Subscribe?.planUploadCount}</td>
                              <td>{Subscribe?.planProductsCount}</td>
                            </tr>
                            <tr className="text-center">
                              <td>Usage Count</td>
                              <td>{Subscribe?.postersCount}</td>
                              <td>{Subscribe?.allListingsCount}</td>
                              <td>{Subscribe?.userCreatedbyvenbdorCounts}</td>
                              <td>{Subscribe?.invoiceAddCounts}</td>
                              <td>{Subscribe?.cashbookCounts}</td>
                              <td>{Subscribe?.uploadCount}</td>
                              <td>{Subscribe?.addProductsCount}</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mb-5">
            <Col md={12}>
              <Row>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <h5 className="mt-2 text-primary">
                        {/* Vendor Information :- */}
                        Business Man Information :-
                      </h5>
                      <Nav pills className="flex-column">
                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "5",
                            })}
                            onClick={() => {
                              toggle1("5")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Profile
                          </NavLink>
                        </NavItem>
                        {/* <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "6",
                            })}
                            onClick={() => {
                              toggle1("6")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Recharge History
                          </NavLink>
                        </NavItem> */}
                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "7",
                            })}
                            onClick={() => {
                              toggle1("7")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Subscription Details
                          </NavLink>
                        </NavItem>
                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "8",
                            })}
                            onClick={() => {
                              toggle1("8")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Business Man Listing
                          </NavLink>
                        </NavItem>
                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "9",
                            })}
                            onClick={() => {
                              toggle1("9")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Rejected Listing
                          </NavLink>
                        </NavItem>
                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "10",
                            })}
                            onClick={() => {
                              toggle1("10")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span> Users
                            List
                          </NavLink>
                        </NavItem>
                        <NavItem className="mt-2">
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "11",
                            })}
                            onClick={() => {
                              toggle1("11")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Post's
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "12",
                            })}
                            onClick={() => {
                              toggle1("12")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Poster's
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            style={{
                              border: "1px #806530 solid",
                              borderRadius: "5px",
                              padding: "8px",
                              margin: "6px",
                            }}
                            className={classnames({
                              active: activeTab1 === "13",
                            })}
                            onClick={() => {
                              toggle1("13")
                            }}
                          >
                            <span className="bx bx-chevrons-right"></span>
                            Referral Users ({forms13.length})
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={9}>
                  <Card>
                    <CardBody>
                      <TabContent activeTab={activeTab1} className="text-muted">
                        <TabPane tabId="5">
                          <Row>
                            <Col lg={4}>
                              <h5 className="mt-2 text-primary">Profile :-</h5>
                              <ul className="list-unstyled vstack gap-3 mb-0">
                                {forms?.profilePic == "" ? (
                                  <>
                                    <img
                                      src={logo}
                                      height="100px"
                                      width="50%"
                                    ></img>
                                  </>
                                ) : (
                                  <>
                                    <img
                                      src={URLS.Base + forms?.profilePic}
                                      height="150px"
                                      width="90%"
                                    ></img>
                                  </>
                                )}
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-user font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Referral Code:
                                      </h6>
                                      <span className="text-muted">
                                        {forms?.referralcode}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-user font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Name:
                                      </h6>
                                      <span className="text-muted">
                                        {forms?.name}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-message-rounded font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Email :
                                      </h6>
                                      {forms?.email}
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-phone font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Contact Number:
                                      </h6>
                                      {forms?.phone}
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-wallet font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Coins:
                                      </h6>
                                      {forms?.coins || 0}
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-area font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Business Type:
                                      </h6>
                                      <span className="text-muted">
                                        {forms?.vendor == false ? (
                                          <>{"Business"}</>
                                        ) : (
                                          <>{"Business"}</>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex mt-3">
                                    <i className="bx bx-wallet-alt font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        GST Number:
                                      </h6>
                                      <span className="text-muted">
                                        {forms?.GSTINnumber}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="d-flex  mt-3">
                                    <i className="bx bx-broadcast font-size-18 text-primary"></i>
                                    <div className="ms-3">
                                      <h6 className="mb-1 fw-semibold">
                                        Status :
                                      </h6>
                                      <span className="badge bg-success">
                                        {forms?.vendor == false ? (
                                          <>{"Active"}</>
                                        ) : (
                                          <>{"InActive"}</>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                            <Col lg={4}>
                              <ul className="verti-timeline list-unstyled ">
                                <h5 className="mb-4 text-primary">
                                  Business Details :-
                                </h5>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        {/* <h6 className="font-size-14 mb-1">
                                          Service
                                        </h6> */}
                                        <h6 className="font-size-14 mb-1">
                                          Category
                                        </h6>
                                        <p className="text-muted">
                                          {/* {forms?.service} */}
                                          {forms?.categoryName}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Business Name
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessName}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Business Phone
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessPhone}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Business Email
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessEmail}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Website
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessWebsite}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>

                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Business Logo
                                        </h6>
                                        <div className="d-flex align-items-center">
                                          <img
                                            src={
                                              URLS.Base + forms?.businessLogo
                                            }
                                            style={{
                                              width: "100px",
                                              cursor: "pointer",
                                            }}
                                            alt="businessLogo"
                                          />
                                          <i
                                            className="bx bx-download"
                                            style={{
                                              fontSize: "24px",
                                              color: "#007bff",
                                              marginLeft: "10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              downloadImage(
                                                URLS.Base + forms?.businessLogo
                                              )
                                            }
                                          ></i>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                            <Col lg={4}>
                              <ul className="verti-timeline list-unstyled ">
                                <h5 className="mb-4 text-primary">
                                  Address Details :-
                                </h5>
                                <li className="event-list mt-5">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Address
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessAddress}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Lattitude / Longitude
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessLatitude} /
                                          {forms?.businessLongitude}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Pin Code
                                        </h6>
                                        <p className="text-muted">
                                          {forms?.businessPincode}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>

                                <li className="event-list">
                                  <div className="event-timeline-dot">
                                    <i className="bx bx-right-arrow-circle"></i>
                                  </div>
                                  <div className="d-flex">
                                    <div className="flex-grow-1">
                                      <div>
                                        <h6 className="font-size-14 mb-1">
                                          Document
                                        </h6>
                                        <p className="text-muted">
                                          {Doc?.map((data, key) => (
                                            //     <div
                                            //       key={key}
                                            //       className="d-inline-flex align-items-center mb-2"
                                            //     >
                                            //       <img
                                            //         src={URLS.Base + data}
                                            //         style={{
                                            //           width: "100px",
                                            //           cursor: "pointer",
                                            //         }}
                                            //         alt={`Document ${key}`}
                                            //         onClick={() =>
                                            //           downloadImage(URLS.Base + data)
                                            //         }
                                            //       />
                                            //        <embed
                                            //   src={URLS.Base + data}
                                            //   type="application/pdf"
                                            //   width="80%"
                                            //   height="235px"
                                            // />
                                            //       <i
                                            //         className="bx bx-download"
                                            //         style={{
                                            //           fontSize: "24px",
                                            //           color: "#007bff",
                                            //           marginLeft: "10px",
                                            //           cursor: "pointer",
                                            //         }}
                                            //         onClick={() =>
                                            //           downloadImage(URLS.Base + data)
                                            //         }
                                            //       ></i>
                                            //     </div>

                                            <div
                                              key={key}
                                              className="d-inline-flex align-items-center mb-2"
                                            >
                                              {/* Check if the data is an image or a PDF */}
                                              {data.endsWith(".jpg") ||
                                              data.endsWith(".png") ||
                                              data.endsWith(".jpeg") ? (
                                                <>
                                                  <img
                                                    src={URLS.Base + data}
                                                    style={{
                                                      width: "100px",
                                                      cursor: "pointer",
                                                    }}
                                                    alt={`Document ${key}`}
                                                    onClick={() =>
                                                      downloadImage(
                                                        URLS.Base + data
                                                      )
                                                    }
                                                  />
                                                  <i
                                                    className="bx bx-download"
                                                    style={{
                                                      fontSize: "24px",
                                                      color: "#007bff",
                                                      marginLeft: "10px",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      downloadImage(
                                                        URLS.Base + data
                                                      )
                                                    }
                                                  ></i>
                                                </>
                                              ) : data.endsWith(".pdf") ? (
                                                <>
                                                  <FaFilePdf
                                                    style={{
                                                      fontSize: "24px",
                                                      color: "#e03e36", // Colorful PDF icon
                                                      marginLeft: "10px",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      handleDownload(
                                                        URLS.Base + data
                                                      )
                                                    }
                                                  />
                                                  <span
                                                    style={{
                                                      marginLeft: "10px",
                                                      fontSize: "16px",
                                                    }}
                                                  >
                                                    Download PDF
                                                  </span>
                                                </>
                                              ) : null}
                                            </div>
                                          ))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="13">
                          <h5 className="text-primary mb-3">
                            Referral Users :-
                          </h5>
                          <Row className="mt-4">
                            <Col md={12}>
                              <div className="table-rep-plugin  table-responsive">
                                <div className="table-rep-plugin table-responsive">
                                  <Table
                                    hover
                                    className="table table-bordered mb-4 "
                                  >
                                    <thead>
                                      <tr className="text-center">
                                        <th>Sl.No</th>
                                        <th>Date</th>
                                        <th>Name</th>
                                        <th>Phone</th>
                                        <th>Profile Pic</th>
                                        <th>Address</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {lists13.map((data, key) => (
                                        <tr key={key} className="text-center">
                                          <td>
                                            {(pageNumber3 - 1) * 5 + key + 6}
                                          </td>
                                          <td>
                                            {data?.logCreatedDate?.slice(0, 10)}
                                          </td>
                                          <td>{data.name}</td>
                                          <td>{data.phone}</td>
                                          <td>
                                            <img
                                              src={
                                                "https://api.jaininternationalnetwork.com/" +
                                                data.profilePic
                                              }
                                              style={{
                                                height: "70px",
                                                width: "70px",
                                              }}
                                            />
                                          </td>
                                          <td>{data.address}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                  <div
                                    className="d-flex mt-3 mb-1"
                                    style={{ float: "right" }}
                                  >
                                    <ReactPaginate
                                      previousLabel={"Previous"}
                                      nextLabel={"Next"}
                                      pageCount={pageCount13}
                                      onPageChange={changePage13}
                                      containerClassName={"pagination"}
                                      previousLinkClassName={"previousBttn"}
                                      nextLinkClassName={"nextBttn"}
                                      disabledClassName={"disabled"}
                                      activeClassName={"active"}
                                      total={lists13.length}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="7">
                          <h5 className="mt-2 text-primary">
                            Plan Information :-
                          </h5>
                          <div className="table-rep-plugin mt-4 table-responsive">
                            <Table hover className="table table-bordered mb-4 ">
                              <thead>
                                <tr className="text-center">
                                  <th>Purchase Date </th>
                                  <th>Expired Date </th>
                                  {/* <th>Plan Amount</th> */}
                                  <th>Offer Price</th>
                                  <th>Payment status </th>
                                  <th>Transtation Id</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="text-center">
                                  {/* <td>{Subscribe?.planName}</td>
                                  <td>
                                    <span className="badge bg-danger">
                                      {Subscribe?.planPurchaseDate?.slice(
                                        0,
                                        10
                                      )}
                                    </span>
                                  </td>
                                  <td>{Subscribe?.planTransactionAmount}</td>
                                  <td>{Subscribe?.planPaymentStatus}</td>
                                  <td>{Subscribe?.planTransactionId}</td> */}
                                  <td>
                                    {" "}
                                    <span className="badge bg-danger">
                                      {Subscribe?.planPurchaseDate?.slice(
                                        0,
                                        10
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    {" "}
                                    <span className="badge bg-danger">
                                      {Subscribe?.planExpiryDate?.slice(0, 10)}
                                    </span>
                                  </td>
                                  <td>{Subscribe?.planTransactionAmount}</td>
                                  <td>{Subscribe?.planPaymentStatus}</td>
                                  <td>{Subscribe?.planTransactionId}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                          <Row className="mt-2">
                            <h5 className="mt-2 text-primary">
                              Plan Details :-
                            </h5>
                            <Col md={12}>
                              <div className="table-rep-plugin mt-4 table-responsive">
                                <Table
                                  hover
                                  className="table table-bordered mb-4 "
                                >
                                  <thead>
                                    <tr className="text-center">
                                      <th>Plan Name</th>
                                      <td>{Subscribe?.planName}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Plan Validity</th>
                                      {/* <td>{Subscribe?.planValidity} Month</td> */}
                                      <td>
                                        {Subscribe?.planValidity
                                          ? `${Subscribe.planValidity} ${
                                              Subscribe.planValidity > 1
                                                ? "Months"
                                                : "Month"
                                            }`
                                          : null}
                                      </td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Plan Price</th>
                                      <td>{Subscribe?.planPrice}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Poster's Count </th>
                                      <td>{Subscribe?.planPostCount}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Listing Count</th>
                                      <td>{Subscribe?.planListingCount}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Cutsomer Add Count</th>
                                      <td>{Subscribe?.planCutsomerAddCount}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Invoice Add Count</th>
                                      <td>{Subscribe?.planInvoiceAddCount}</td>
                                    </tr>

                                    <tr className="text-center">
                                      <th>CashBook Entries Count</th>
                                      <td>
                                        {Subscribe?.planCashBookEntriesCount}
                                      </td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Upload Count</th>
                                      <td>{Subscribe?.planUploadCount}</td>
                                    </tr>
                                    <tr className="text-center">
                                      <th>Products Count</th>
                                      <td>{Subscribe?.planProductsCount}</td>
                                    </tr>
                                  </thead>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="8">
                          <h5 className="text-primary mb-3">
                            {/* Vendor Listing :- */}
                            Business Man Listing :-
                          </h5>
                          <Row className="mt-4">
                            <Col>
                              <div className="table-rep-plugin mt-4 table-responsive">
                                <Table
                                  hover
                                  className="table table-bordered mb-4 "
                                >
                                  <thead>
                                    <tr className="text-center">
                                      <th>Sl.No</th>
                                      <th>Business Image</th>
                                      <th>Category Name</th>
                                      <th>Status</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  {/* <tbody>
                                    {lists1?.map((data, key) => (
                                      <tr key={key} className="text-center">
                                        <td>{key + 1}</td>
                                        <td>
                                          <img
                                            src={
                                              URLS.Base + data?.serviceImg[0]
                                            }
                                            style={{ width: "80px" }}
                                          />
                                        </td>
                                        <td>{data.categoryName}</td>
                                        <td>{data.listingStatus}</td>
                                        <td>
                                          <Button
                                            onClick={() => {
                                              Actinid1(data)
                                            }}
                                            size="sm"
                                            className="m-1"
                                            color="info"
                                          >
                                            <div className="d-flex">
                                              <small>
                                                <i className="fas fa-eye m-1"></i>
                                                View
                                              </small>
                                            </div>
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody> */}
                                  <tbody>
                                    {lists1?.map((data, key) => (
                                      <tr key={key} className="text-center">
                                        <td>{key + 1}</td>
                                        <td>
                                          <div className="d-flex align-items-center">
                                            <img
                                              src={
                                                URLS.Base +
                                                data?.businessLogo[0]
                                              }
                                              style={{
                                                width: "100px",
                                                cursor: "pointer",
                                              }}
                                              alt={`Service ${key}`}
                                            />
                                            <i
                                              className="bx bx-download"
                                              style={{
                                                fontSize: "24px",
                                                color: "#007bff",
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                downloadImage(
                                                  URLS.Base +
                                                    data?.businessLogo[0]
                                                )
                                              }
                                            ></i>
                                          </div>
                                        </td>
                                        <td>{data.categoryName}</td>
                                        <td>{data.listingStatus}</td>
                                        <td>
                                          <Button
                                            onClick={() => Actinid1(data)}
                                            size="sm"
                                            className="m-1"
                                            color="info"
                                          >
                                            <div className="d-flex">
                                              <small>
                                                <i className="fas fa-eye m-1"></i>
                                                View
                                              </small>
                                            </div>
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                                <div
                                  className="d-flex mt-3 mb-1"
                                  style={{ float: "right" }}
                                >
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount1}
                                    onPageChange={changePage1}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists1.length}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="9">
                          <h5 className="text-primary mb-3">
                            Rejected Listing :-
                          </h5>
                          <Row className="mt-4">
                            <div className="table-rep-plugin mt-4 table-responsive">
                              <Table
                                hover
                                className="table table-bordered mb-4 "
                              >
                                <thead>
                                  <tr className="text-center">
                                    <th>Sl.No</th>
                                    <th>Business Image</th>
                                    <th>Category Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {lists3?.map((data, key) => (
                                    <tr key={key} className="text-center">
                                      <td>{key + 1}</td>
                                      <td>
                                        {/* <img
                                          src={URLS.Base + data.serviceImg[0]}
                                          style={{ width: "80px" }}
                                        /> */}
                                        <div className="d-inline-block">
                                          <img
                                            style={{
                                              width: "80px",
                                              cursor: "pointer",
                                            }}
                                            src={URLS.Base + data.serviceImg[0]}
                                            alt={`Template ${key}`}
                                            onClick={() =>
                                              downloadImage(
                                                URLS.Base + data.serviceImg[0]
                                              )
                                            }
                                          />
                                          <i
                                            className="bx bx-download"
                                            style={{
                                              fontSize: "24px",
                                              color: "#007bff",
                                              marginLeft: "10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              downloadImage(
                                                URLS.Base + data.serviceImg[0]
                                              )
                                            }
                                          ></i>
                                        </div>
                                      </td>
                                      <td>{data.categoryName}</td>
                                      <td>{data.categoryName}</td>
                                      <td>{data.listingStatus}</td>
                                      <td>
                                        <Button
                                          onClick={() => {
                                            Actinid1(data)
                                          }}
                                          size="sm"
                                          className="m-1"
                                          color="info"
                                        >
                                          <div className="d-flex">
                                            <small>
                                              <i className="fas fa-eye m-1"></i>
                                              View
                                            </small>
                                          </div>
                                        </Button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <div
                                className="d-flex mt-3 mb-1"
                                style={{ float: "right" }}
                              >
                                <ReactPaginate
                                  previousLabel={"Previous"}
                                  nextLabel={"Next"}
                                  pageCount={pageCount3}
                                  onPageChange={changePage3}
                                  containerClassName={"pagination"}
                                  previousLinkClassName={"previousBttn"}
                                  nextLinkClassName={"nextBttn"}
                                  disabledClassName={"disabled"}
                                  activeClassName={"active"}
                                  total={lists3.length}
                                />
                              </div>
                            </div>
                          </Row>
                        </TabPane>
                        <TabPane tabId="10">
                          <h5 className="text-primary mb-3">Users List :-</h5>
                          <Row className="mt-4">
                            <Col md={12}>
                              <div className="table-rep-plugin table-responsive">
                                <Table hover bordered responsive>
                                  <thead>
                                    <tr className="text-center">
                                      <th>Sl No</th>
                                      <th>Name</th>
                                      <th>Phone No</th>
                                      <th>Date of Birth</th>
                                      <th>Anniversery</th>
                                      <th>Whatsapp</th>
                                      {/* <th>Community</th> */}
                                      <th>Business Type </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {lists4.map((data, key) => (
                                      <tr key={key} className="text-center">
                                        <td>{key + 1}</td>
                                        <td>{data.name}</td>
                                        <td>{data.phone}</td>
                                        <td>{data.dateOfBirth}</td>
                                        <td>{data.anniversery}</td>
                                        <td>{data.whatsapp}</td>
                                        {/* <td>{data.community}</td> */}
                                        <td>
                                          {data.vendor == false ? (
                                            <>{"individual"}</>
                                          ) : (
                                            <>{"Business"}</>
                                          )}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                                <div
                                  className="d-flex mt-3 mb-1"
                                  style={{ float: "right" }}
                                >
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount4}
                                    onPageChange={changePage4}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists4.length}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="11">
                          <h5 className="text-primary mb-3">Post's :-</h5>
                          <Row>
                            <Col md={12}>
                              <div className="table-rep-plugin table-responsive">
                                <Table hover bordered responsive>
                                  <thead>
                                    <tr className="text-center">
                                      <th>Sl.No</th>
                                      <th>Description</th>
                                      <th>Image</th>
                                    </tr>
                                  </thead>
                                  <tbody className="text-center">
                                    {Posts.map((data, key) => (
                                      <tr key={key}>
                                        <td>{key + 1}</td>
                                        <td>{data.description}</td>
                                        <td>
                                          <Button
                                            outline
                                            color="warning"
                                            className="btn-sm"
                                            onClick={() => {
                                              getinc(data)
                                            }}
                                          >
                                            <div className="d-flex">
                                              <i className="bx bxs-file"></i>
                                              <small>View</small>
                                            </div>
                                          </Button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              </div>
                            </Col>
                          </Row>
                        </TabPane>
                        <TabPane tabId="12">
                          <Row>
                            <h5
                              className="modal-title mt-0"
                              id="mySmallModalLabel"
                            >
                              Poster's
                            </h5>
                            <div className="table-rep-plugin table-responsive mt-3">
                              <Table hover bordered responsive>
                                <thead>
                                  <tr className="text-center">
                                    <th>Sl.No</th>
                                    <th>Template Name</th>
                                    <th>Template Image</th>
                                  </tr>
                                </thead>
                                <tbody className="text-center">
                                  {lists5.map((data, key) => (
                                    <tr key={key}>
                                      <td>{(pageNumber5 - 1) * 5 + key + 6}</td>
                                      <td>{data.templateName}</td>
                                      <td>
                                        <img
                                          src={URLS.Base + data.templateImage}
                                          height="120px"
                                        ></img>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                              <Col md={12}>
                                <div
                                  className="d-flex mt-3 mb-1"
                                  style={{ float: "right" }}
                                >
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount5}
                                    onPageChange={changePage5}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists5.length}
                                  />
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Modal
          size="lg"
          isOpen={info}
          toggle={() => {
            infos()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              View
            </h5>
            <button
              onClick={() => {
                setinfo(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <a href={URLS.Base + Instructions} target="_blank" rel="noreferrer">
              <iframe
                src={URLS.Base + Instructions}
                style={{ height: "500px", width: "100%" }}
              ></iframe>{" "}
            </a>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default State
